// extracted by mini-css-extract-plugin
export default {"hero-gradient-background":"hero_hero-gradient-background__9wD-s","hero-video":"hero_hero-video__OmY7C","hero-text":"hero_hero-text__hUU+c","hero-overlay":"hero_hero-overlay__+X+Ud"};